import React, { Component } from 'react';
import { Menu } from 'element-react';
import './Login.css';
import { Form, Input, Button } from 'element-react';
import logo from '../../assets/logo.png';
import firebase from 'firebase';

class Login extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			form: {
				email: '',
				password: '',
			},
			rules: {
				email: [
					{ required: true, message: 'Introduce tu email', trigger: 'blur' },
				],
				password: [
					{ required: true, message: 'Introduce la contraseña', trigger: 'blur' },
				],
			}
		};

	}

	handleSubmit(e) {
		e.preventDefault();
	
		this.refs.form.validate((valid) => {
			if (valid) {
				firebase.auth().signInWithEmailAndPassword(this.state.form.email, this.state.form.password)
				.then( (user) => {
					//console.log('user: ', user.email);
				})
				.catch((error) => {
					// Handle Errors here.
					let errorCode = error.code;
					let errorMessage = error.message;
					// ...
					console.log(errorMessage);
					//alert('Credenciales incorrectas');
				});
			} else {
				return false;
			}
		});
	}

	onChange(key, value) {
		this.setState({
			form: Object.assign({}, this.state.form, { [key]: value })
		});
	}

	render() {
		return (
			<div className="loginWrapper">
				<img src={logo} alt="Logo" />
				<div className="dataWrapper">
					<Form ref="form" model={this.state.form} rules={this.state.rules} labelWidth="100" className="demo-ruleForm">
						<Form.Item label="Email" prop="email">
							<Input style={{ color: 'white' }} type="email" value={this.state.form.email} onChange={this.onChange.bind(this, 'email')} autoComplete="off" />
						</Form.Item>
						<Form.Item label="Contraseña" prop="password">
							<Input type="password" value={this.state.form.password} onChange={this.onChange.bind(this, 'password')} autoComplete="off" />
						</Form.Item>
						<Form.Item>
							<Button type="success" onClick={this.handleSubmit.bind(this)}>ENTRAR</Button>
						</Form.Item>
					</Form>
				</div>
			</div>
		)
	}
}

export default Login;


// WEBPACK FOOTER //
// ./src/components/Login/Login.jsx